export const BUILD_VERSION = '1779894100';
